<form class="form-group">
  <div class="input-group has-postfix week-picker">
    <input
      class="form-control"
      placeholder="yyyy-mm-dd"
      name="dp"
      (ngModel)="(model)"
      [ngModel]="selectedWeek?.start"
      ngbDatepicker
      #d="ngbDatepicker"
      (click)="d.toggle()"
      (ngModelChange)="onDateSelection($event)"
      [readonly]="true"
    />
    <div class="form-control weekpicker-values">
      <span *ngIf="selectedWeek?.start?.day">
        <span> {{ selectedWeek?.start?.month }}/{{ selectedWeek?.start?.day }}/{{ selectedWeek?.start?.year }} </span>
        <span class="text-body-tertiary"> to </span>
        <span> {{ selectedWeek?.end?.month }}/{{ selectedWeek?.end?.day }}/{{ selectedWeek?.end?.year }} </span>
      </span>
      <span *ngIf="!selectedWeek?.start?.day" class="weekpicker-values placeholder"> Select Week </span>
    </div>
    <span class="postfix bi bi-calendar3"></span>
  </div>
</form>
